<template>
  <v-card
    :class="{ 'fill-height': (!isMobile && !hideDetails)}"
    :loading="loading"
    :flat="flat"
    :outlined="outlined"
  >
    <v-card-title v-if="!hideTitle">
      Οικονομικές εκκρεμότητες
      <v-icon
        v-tooltip="
          'Οικονομικές εκκρεμότητες οι οποίες δεν έχουν εξοφληθεί, ή βρίσκονται σε αναμονή.' +
          ' Οικονομικές εκκρεμότητες σε αναμονή αφορούν παραστατικά, τα οποία δεν έχουν εκδοθεί ακόμα.'
        "
      >
        mdi-help-circle-outline
      </v-icon>
    </v-card-title>
    <v-row v-if="!isMobile && !hideHeader">
      <v-col>
        <div class="pa-4">
          <span style="font-size: 0.8em"> Υπόλοιπο</span>
          <br />
          <span class="display-1 text--primary">
            {{ (totalDept - totalDeptStandBy) | fixed }}‎€
          </span>
        </div>
      </v-col>
      <v-col>
        <div class="pa-4">
          <span style="font-size: 0.8em"> Σε αναμονή</span>
          <br />
          <span class="display-1" style="color: #333">
            {{ totalDeptStandBy | fixed }}‎€
          </span>
        </div>
      </v-col>
    </v-row>
    <v-row class="mr-2 ml-2"  v-if="isMobile && !hideHeader">
      <v-col>
        <span style="font-size: 1em"> Υπόλοιπο :</span>
        <br />
        <span style="font-size: 1.5em">
          {{ (totalDept - totalDeptStandBy) | fixed }}‎€
        </span>
      </v-col>
      <v-col>
        <span style="font-size: 1em"> Σε αναμονή :</span>
        <br />
        <span style="font-size: 1.5em"> {{ totalDeptStandBy | fixed }}‎€ </span>
      </v-col>
    </v-row>
    <v-list
      v-if="!hideDetails"
      :max-height="maxHeight"
      style="overflow-y: auto"
    >
      <v-list-item v-if="openDepts.length === 0">
        <v-list-item-content> Δεν έχετε καμία οφειλή. </v-list-item-content>
      </v-list-item>
      <dept-item
        show-branch-address
        v-for="dept in openDepts.slice(0, 8)"
        :dept="dept"
        :key="dept.PartnerMvItm_ID"
      />
    </v-list>
    <v-card-actions v-if="!hideButtons" class="pt-0">
      <v-btn
        color="success"
        text
        v-if="userDetails.Allows.AllowPayments"
        to="/financial/dept/payments"
      >
        ΠΛΗΡΩΜΗ</v-btn
      >
      <v-btn text color="primary" to="/financial/dept"> ΌΛΕΣ</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import DeptItem from "@/views/Financial/components/DeptItem";

export default {
  name: "DeptOverview",
  components: { DeptItem },
  props: {
    flat: Boolean,
    outlined: Boolean,
    loading: Boolean,
    hideDetails: Boolean,
    hideButtons: Boolean,
    hideTitle:Boolean,
    maxHeight: { type: String, default: "50vh", required: false },
    hideHeader: { type: Boolean, default: null, required: false },
  },
  computed: {
    ...mapGetters([
      "isMobile",
      "totalDept",
      "openDepts",
      "totalDeptStandBy",
      "userDetails",
      "userDetails",
      "ongoingCallouts",
    ]),
  },
};
</script>

<style scoped>
</style>
